import { gql } from '@apollo/client';

export const PROTOCOLS_LIST = gql`
  query Protocols($count: Int) {
    protocols(count: $count) {
      data {
        name
        id
        clinicId
        status
      }
    }
  }
`;
